import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=2474630e"
var script = {}
import style0 from "./friends.vue?vue&type=style&index=0&id=2474630e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports